import { useState, useRef } from 'react';
import { toast } from 'react-toastify';

const useExcelUpload = ({ onFileSelect } = {}) => {
  const [file, setFile] = useState(null);
  const fileInputRef = useRef(null);

  const handleFileSelect = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = event => {
    const selectedFile = event.target.files[0];
    if (!selectedFile) return;

    const allowedExtensions = ['xlsx', 'xls'];
    const fileExtension = selectedFile.name.split('.').pop()?.toLowerCase();

    const isExcel =
      selectedFile.type ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
      selectedFile.type === 'application/vnd.ms-excel' ||
      (fileExtension && allowedExtensions.includes(fileExtension));

    if (isExcel) {
      setFile(selectedFile);
      onFileSelect?.(selectedFile);
    } else {
      toast.error('Please upload only Excel files (.xlsx or .xls)');
      resetFile();
    }
  };

  const resetFile = () => {
    setFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  return {
    file,
    fileInputRef,
    handleFileSelect,
    handleFileChange,
    resetFile,
  };
};

export default useExcelUpload;
